import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { TableColumn, ButtonComponent } from '@ui/aos-lib';
import { SubscriptionManagementPageContext, SubscriptionManagement } from '../../subscription-management.types';

@Component({
  template: `
    <ui-button
      [iconName]="'pencil'"
      [size]="'small'"
      (click)="onColumnClick()"
    ></ui-button>
  `,
  imports: [ButtonComponent]
})
export class EditModalColumnComponent {
  private subscriptionManagementPageComponent = inject(SubscriptionManagementPageContext, { optional: true });

  @Output() refreshClick = new EventEmitter();

  @Input() item!: SubscriptionManagement;
  @Input() column!: TableColumn;

  protected onColumnClick(): void {
    const {
      subscriptionName,
      channel,
      commodity,
      reportGroup,
      contact,
      delivery,
      eventGroup,
      eventName,
      severityRules
    } = this.item;

    this.subscriptionManagementPageComponent!.editSubscriptionFormData = {
      subscriptionName,
      channel,
      commodity,
      reportGroup,
      contact,
      delivery,
      eventGroup,
      eventName,
      Critical: this.isSeverityPresent(severityRules, 'Critical'),
      Severe: this.isSeverityPresent(severityRules, 'Severe'),
      Warning: this.isSeverityPresent(severityRules, 'Warning'),
      Notice: this.isSeverityPresent(severityRules, 'Notice')
    };
    this.subscriptionManagementPageComponent!.subscriptionId = this.item.subscriptionId;

    this.subscriptionManagementPageComponent!.openModal();
  }

  private isSeverityPresent(arr: string[], severity: string): boolean {
    return arr.some(arrVal => severity === arrVal);
  }
}
